import { mergeProps } from '@zag-js/solid';
import { ark } from '../factory';
import { usePaginationContext } from './use-pagination-context';
export const PaginationNextTrigger = (props) => {
    const api = usePaginationContext();
    const mergedProps = mergeProps(() => api().getNextTriggerProps(), props);
    return <ark.button {...mergedProps}/>;
};
